module.exports = __webpack_public_path__ + "images/quickbooks_logo.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/quickbooks_logo.png
// module id = 1193
// module chunks = 0